// removed by extract-text-webpack-plugin
module.exports = {"confirmation":"qempo_Received_confirmation-1QS3gZ2","title":"qempo_Received_title-3mUviYq","receivedCheckbox":"qempo_Received_receivedCheckbox-24Fg0tz","report":"qempo_Received_report-2l5K-77","confirmArrival":"qempo_Received_confirmArrival-vogb0nK","line":"qempo_Received_line-p3dePlE","bottomMessage":"qempo_Received_bottomMessage-2xHEoEp","buttonsWrap":"qempo_Received_buttonsWrap-2SPBt1S","below":"qempo_Received_below-3jDu6YL"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Sale/received/components/Received.scss
// module id = 1873
// module chunks = 0